import React from "react";

export default function Function() {

    return (
        <div className="p-2 c-light-2">
            <div className="p-2 w-75 m-auto bg-dark-4 star-border bg-pattern-1">
                <h1 className="p-2 text-center mar-top-4">About the Studio</h1>

{/*
                <h6 className="ts-i text-center pad-top-4 c-light-4 ft-secondary">
                    A passionate game designer exploring new ideas and approaches to game development
                </h6>
                <h6 className="ts-i text-center pad-bottom-4 c-light-4 ft-secondary">
                    Crafting Games and Tools that Inspire
                </h6>
*/}                

                <p className="p-3">
                    Magikus Studios is the personal development studio of an Argentine software engineer with a deep passion for Unity, creativity and well-crafted systems.
                    After years of experimenting with different fields (from physics to game development) and working professionally in other areas, I eventually found in Unity the perfect space to bring together everything I love: programming, design and interactive experiences.
                </p>

                <p className="p-3">
                    Magikus Studios grew naturally from my own development journey.
                    What began as a collection of tools and code I built to make my workflow smoother soon became something more structured, something I wanted to share.
                    Over time, that collection evolved into Magikus, a full Unity toolkit designed to help developers work faster, smarter and more creatively.
                </p>

                <p className="p-3">
                    But Magikus Studios isn’t just about tools.
                    It’s a personal space where I explore ideas, build systems and turn technical challenges into creative opportunities.
                    Whether it’s a toolkit, a small game or an experimental concept, each project reflects my approach to development: thoughtful, practical and always growing.
                </p>

                <p className="p-3">
                    This studio represents not just what I make, but how I work: independently, passionately and with the belief that the best ideas come from curiosity, patience and a love for learning.
                </p>

                <p className="p-3">
                    Created by Lucas Di Fresco
                </p>
            </div>
            <div className="p-3"></div>
            <div className="p-5"></div>
        </div>
    );
}